import store from "@/store/index.js";

export const PermissionPlugin = {
  install(Vue) {
    Vue.prototype.$can = store.getters["permissions/hasPermission"];
  },
};
